import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Container, Alert } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import config from '../config';
import axios from 'axios';

const OAuthCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setAuthSession } = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const handleOAuthCallback = async () => {
      try {
        const provider = searchParams.get('provider') || 'google';
        const accessToken = searchParams.get('access_token') || searchParams.get('id_token');
        const errorMessage = searchParams.get('error');

        if (errorMessage) {
          setError(errorMessage);
          setLoading(false);
          return;
        }

        if (!accessToken) {
          setError('missing access token');
          setLoading(false);
          return;
        }

        const authResponse = await axios.get(
          `${config.API_BASE}/api/auth/${provider}/callback`,
          {
            params: {
              access_token: accessToken,
            },
          }
        );

        const jwt = authResponse.data?.jwt;
        const fallbackUser = authResponse.data?.user || null;

        if (!jwt) {
          setError('oauth jwt missing');
          setLoading(false);
          return;
        }

        const currentUser = await setAuthSession(jwt, fallbackUser);
        const needsOnboarding = Boolean(currentUser?.needsOnboarding);

        navigate(needsOnboarding ? '/profile' : '/');
      } catch (err) {
        console.error('OAuth callback error:', err);
        setError('OAuth authentication failed');
        setLoading(false);
      }
    };

    handleOAuthCallback();
  }, [searchParams, navigate, setAuthSession]);

  return (
    <Container className="py-5">
      {loading && (
        <div className="text-center">
          <p>Processing authentication...</p>
        </div>
      )}
      {error && (
        <Alert variant="danger">
          <p>Authentication failed: {error}</p>
          <p>Please <a href="/login">try logging in again</a></p>
        </Alert>
      )}
    </Container>
  );
};

export default OAuthCallbackPage;
